const values = [
  {
    icon: 'ri-shield-check-line',
    title: '100% 正品保障',
    desc: '每件服飾皆附原廠標籤與品牌授權證明，讓您以 Outlet 優惠價安心購得精品。全程透明，假一賠十。',
    detail: '查看保障說明',
  },
  {
    icon: 'ri-eye-line',
    title: '透明貨源',
    desc: '直接與品牌商及代理商合作，跳過中間商溢價環節，省下的成本直接回饋給每一位喜愛時尚的妳。',
    detail: '了解貨源機制',
  },
  {
    icon: 'ri-store-2-line',
    title: '台中門市試穿',
    desc: '位於台中市中心的實體門市，完整陳列所有在售品項。歡迎親臨試穿，由專業時尚顧問為您搭配造型。',
    detail: '查看門市資訊',
  },
];

export default function ValueProposition() {
  return (
    <section id="values" className="bg-cream-100 py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14 md:mb-18">
          <span className="inline-block border border-gold-400 text-gold-500 text-sm font-sans-body tracking-widest px-4 py-1.5 rounded-full mb-5 font-medium">
            BRAND VALUE
          </span>
          <h2 className="font-serif-title text-[1.5rem] md:text-[2.125rem] text-warm-900 font-semibold leading-[1.4] mb-4">
            為什麼選擇我們
          </h2>
          <p className="font-sans-body text-[1.1875rem] text-warm-900/65 leading-[1.75] max-w-xl mx-auto">
            我們相信每一位女性都值得穿著品質出色的服飾，而不必為此傾盡荷包。
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {values.map((v) => (
            <div
              key={v.title}
              className="group bg-white rounded-2xl p-8 md:p-10 border border-cream-200 hover:border-gold-300 hover:bg-cream-50 transition-all duration-300 cursor-default"
            >
              {/* Icon */}
              <div className="w-12 h-12 flex items-center justify-center bg-cream-100 group-hover:bg-gold-100 rounded-xl mb-6 transition-colors duration-300">
                <i className={`${v.icon} text-xl text-gold-500`}></i>
              </div>

              {/* Title */}
              <h3 className="font-serif-title text-[1.25rem] md:text-[1.625rem] text-warm-900 font-semibold leading-[1.5] mb-3">
                {v.title}
              </h3>

              {/* Desc */}
              <p className="font-sans-body text-[1.1875rem] text-warm-900/65 leading-[1.75] mb-6">
                {v.desc}
              </p>

              {/* CTA */}
              <button className="whitespace-nowrap flex items-center gap-1.5 text-[1rem] font-medium text-gold-500 group-hover:text-gold-600 transition-colors cursor-pointer">
                {v.detail}
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-base"></i>
                </span>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
